import { message } from "antd";
import posthog, { isPostHogReady } from "../analytics/posthogClient";

/** Product analytics via PostHog only (Google Analytics removed). */
export const eventTracker = (category, action, label) => {
  if (!category || !action) {
    message.error("Category and action are required for tracking events");
    return;
  }

  if (isPostHogReady()) {
    posthog.capture(label ? `${category}: ${label}` : `${category}: ${action}`, {
      category,
      action,
      label,
    });
  }
};
